import { PcApiResponse } from '@/api/pc-api/types';
import { Set4Product } from '@/api/pc-api/v1/product/list/types';
import { api } from '@/utils/api';

export const getProductListSet4 = (isTest?: boolean) => {
  return api<PcApiResponse<Set4Product[]>>('get', `/pc-api/v1/product/list/set4`, { isTest });
};
